import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/opt/render/project/src/node_modules/.pnpm/gatsby-theme-docz@2.3.1_@babel+core@7.11.1_@types+node@24.7.0_docz@2.4.0_@babel+core@7._04842b0c5656885ffb9b2f355e30df2b/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "credits-gadget-test-instructions"
    }}>{`Credits Gadget Test Instructions`}</h1>
    <h2 {...{
      "id": "overview"
    }}>{`Overview`}</h2>
    <p>{`These tests verify the Credits calculation feature in the Programs form's Prerequisites/Requirements section. The Credits Gadget calculates total credits based on different rule types.`}</p>
    <h2 {...{
      "id": "prerequisites"
    }}>{`Prerequisites`}</h2>
    <ul>
      <li parentName="ul">{`Access to Kuali Curriculum Form Builder`}</li>
      <li parentName="ul">{`Navigate to: Programs > Requirements page (page 5) > Graduation Requirements section`}</li>
      <li parentName="ul">{`Ensure the form is in Preview mode (toggle at top of page)`}</li>
    </ul>
    <h2 {...{
      "id": "test-data"
    }}>{`Test Data`}</h2>
    <h3 {...{
      "id": "courses"
    }}>{`Courses`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Course`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Credits`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`ACC101 - Introduction to Financial Accounting`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`3`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`ACC201 - Introduction to Managerial Accounting`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`3`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`ACC301 - Intermediate Accounting I`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`3`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`ACC302 - Intermediate Accounting II`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`3`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`ACC310 - Auditing and Assurance Services`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`3`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`ACC450 - Advanced Financial Reporting`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`3`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`DNC201 - Introduction to Dance`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`2`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "course-sets"
    }}>{`Course Sets`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Accounting Core`}</strong>{`: Contains 7 courses totaling ~20-21 credits`}</li>
    </ul>
    <h3 {...{
      "id": "subjects"
    }}>{`Subjects`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`ACC`}</strong>{`: Accounting subject code`}</li>
    </ul>
    <hr></hr>
    <h2 {...{
      "id": "test-cases"
    }}>{`Test Cases`}</h2>
    <h3 {...{
      "id": "test-1-completed-the-following---courses"
    }}>{`Test 1: Completed the following - courses`}</h3>
    <p><strong parentName="p">{`Rule`}</strong>{`: Completed the following: `}{`[courses]`}{`
`}<strong parentName="p">{`Setup`}</strong>{`: Add ACC101 (3 credits) and DNC201 (2 credits)
`}<strong parentName="p">{`Expected`}</strong>{`: 5 Credits
`}<strong parentName="p">{`Behavior`}</strong>{`: Shows sum of all selected course credits`}</p>
    <hr></hr>
    <h3 {...{
      "id": "test-2-completed-at-least--of-courses---courses"
    }}>{`Test 2: Completed at least # of courses - courses`}</h3>
    <p><strong parentName="p">{`Rule`}</strong>{`: Completed at least 2 of the following: `}{`[courses]`}{`
`}<strong parentName="p">{`Setup`}</strong>{`: Add ACC101 (3), ACC301 (3), DNC201 (2) - total 3 courses
`}<strong parentName="p">{`Expected`}</strong>{`: 5-6 Credits (range)
`}<strong parentName="p">{`Behavior`}</strong>{`: Shows credit range from minimum possible (2 lowest: 2+3=5) to maximum possible (2 highest: 3+3=6)`}</p>
    <hr></hr>
    <h3 {...{
      "id": "test-3-completed-at-least--of-courses---course-sets"
    }}>{`Test 3: Completed at least # of courses - course sets`}</h3>
    <p><strong parentName="p">{`Rule`}</strong>{`: Completed at least 3 of the following: `}{`[course sets]`}{`
`}<strong parentName="p">{`Setup`}</strong>{`: Add Accounting Core, set number to 3
`}<strong parentName="p">{`Expected`}</strong>{`: 8-10 Credits (range)
`}<strong parentName="p">{`Behavior`}</strong>{`: Shows credit range based on selecting 3 courses from the course set`}</p>
    <hr></hr>
    <h3 {...{
      "id": "test-4-completed-the-following---course-sets"
    }}>{`Test 4: Completed the following - course sets`}</h3>
    <p><strong parentName="p">{`Rule`}</strong>{`: Completed the following: `}{`[course sets]`}{`
`}<strong parentName="p">{`Setup`}</strong>{`: Add Accounting Core
`}<strong parentName="p">{`Expected`}</strong>{`: ~21 Credits
`}<strong parentName="p">{`Behavior`}</strong>{`: Shows sum of all credits in the course set`}</p>
    <hr></hr>
    <h3 {...{
      "id": "test-5-completed-at-least--of-courses---courses-duplicate-of-test-2"
    }}>{`Test 5: Completed at least # of courses - courses (duplicate of Test 2)`}</h3>
    <p><strong parentName="p">{`Skip`}</strong>{` - same rule type as Test 2`}</p>
    <hr></hr>
    <h3 {...{
      "id": "test-6-completed-at-least--of-courses---course-sets-duplicate-of-test-3"
    }}>{`Test 6: Completed at least # of courses - course sets (duplicate of Test 3)`}</h3>
    <p><strong parentName="p">{`Skip`}</strong>{` - same rule type as Test 3`}</p>
    <hr></hr>
    <h3 {...{
      "id": "test-7-completed-at-least--courses-from---subjects"
    }}>{`Test 7: Completed at least # courses from - subjects`}</h3>
    <p><strong parentName="p">{`Rule`}</strong>{`: Completed at least 3 courses from: `}{`[subjects]`}{`
`}<strong parentName="p">{`Setup`}</strong>{`: Add ACC subject, set number to 3
`}<strong parentName="p">{`Expected`}</strong>{`: 9-10 Credits (range)
`}<strong parentName="p">{`Behavior`}</strong>{`: Shows credit range based on selecting 3 courses from ACC subject`}</p>
    <hr></hr>
    <h3 {...{
      "id": "test-8-completed-at-least--credits-from---courses"
    }}>{`Test 8: Completed at least # credits from - courses`}</h3>
    <p><strong parentName="p">{`Rule`}</strong>{`: Completed at least 6 credits from the following: `}{`[courses]`}{`
`}<strong parentName="p">{`Setup`}</strong>{`: Add ACC101 (3), ACC301 (3), DNC201 (2), set credits to 6
`}<strong parentName="p">{`Expected`}</strong>{`: 6 Credits
`}<strong parentName="p">{`Behavior`}</strong>{`: Shows the specified minimum credit amount`}</p>
    <hr></hr>
    <h3 {...{
      "id": "test-9-completed-at-least--credits-from---course-sets"
    }}>{`Test 9: Completed at least # credits from - course sets`}</h3>
    <p><strong parentName="p">{`Rule`}</strong>{`: Completed at least 10 credits from the following: `}{`[course sets]`}{`
`}<strong parentName="p">{`Setup`}</strong>{`: Add Accounting Core, set credits to 10
`}<strong parentName="p">{`Expected`}</strong>{`: 10 Credits
`}<strong parentName="p">{`Behavior`}</strong>{`: Shows the specified minimum credit amount`}</p>
    <hr></hr>
    <h3 {...{
      "id": "test-10-completed-at-least--credits-from---subjects"
    }}>{`Test 10: Completed at least # credits from - subjects`}</h3>
    <p><strong parentName="p">{`Rule`}</strong>{`: Completed at least 9 credits from: `}{`[subjects]`}{`
`}<strong parentName="p">{`Setup`}</strong>{`: Add ACC subject, set credits to 9
`}<strong parentName="p">{`Expected`}</strong>{`: 9 Credits
`}<strong parentName="p">{`Behavior`}</strong>{`: Shows the specified minimum credit amount`}</p>
    <hr></hr>
    <h2 {...{
      "id": "execution-steps"
    }}>{`Execution Steps`}</h2>
    <ol>
      <li parentName="ol">{`Navigate to Programs > Requirements page`}</li>
      <li parentName="ol">{`Ensure form is in Preview mode`}</li>
      <li parentName="ol">{`In Graduation Requirements section, click + Rule`}</li>
      <li parentName="ol">{`Select the appropriate rule type from the RULES modal`}</li>
      <li parentName="ol">{`Configure the rule with the specified values`}</li>
      <li parentName="ol">{`Verify the Total Credits displays the expected value`}</li>
      <li parentName="ol">{`Click Discard to reset before the next test (switch to Design mode if needed)`}</li>
    </ol>
    <h2 {...{
      "id": "expected-behaviors-summary"
    }}>{`Expected Behaviors Summary`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Rule Pattern`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Credit Display`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`"Completed the following"`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Sum of all selected items`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`"Completed at least X of Y" (courses)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Range (min to max)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`"Completed at least X of Y" (course sets)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Range (min to max)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`"Completed at least X credits from"`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Fixed amount (X)`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "notes"
    }}>{`Notes`}</h2>
    <ul>
      <li parentName="ul">{`Empty rules are automatically removed if not populated quickly`}</li>
      <li parentName="ul">{`Toggle Design/Preview mode if Discard button is disabled`}</li>
      <li parentName="ul">{`Credit ranges appear when the rule allows choice (e.g., "at least 2 of 3")`}</li>
      <li parentName="ul">{`Fixed credit amounts appear when specifying minimum credits required`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      